/**
 * IG Buy Box — One-Time as a text link
 *
 * Theme: window.__IG_BB_OTP_LINK_CFG__ from product section settings.
 * Intelligems: paste this file alone (no cfg → runs when #ig-bb exists).
 *
 * OTP link adds the one-time variant via the existing .ig-atc handler
 * (no selling_plan) without switching the buybox layout.
 */
(function () {
  if (window.__IG_BB_OTP_LINK_RUNNING__) return;
  window.__IG_BB_OTP_LINK_RUNNING__ = true;

  var ROOT_ID = 'ig-bb';
  var STYLE_ID = 'ig-bb-otp-link-style';
  var cfg = window.__IG_BB_OTP_LINK_CFG__ || null;
  var done = false;
  var applying = false;
  var wiredSticky = false;

  function parseIds(raw) {
    if (!raw) return [];
    if (Array.isArray(raw)) return raw.map(String);
    return String(raw)
      .split(/[\s,]+/)
      .map(function (s) {
        return s.trim();
      })
      .filter(Boolean);
  }

  function hasClass(name) {
    if (!name) return false;
    return (
      document.body.classList.contains(name) ||
      document.documentElement.classList.contains(name)
    );
  }

  function currentProductId() {
    if (cfg && cfg.currentProductId != null) return String(cfg.currentProductId);
    try {
      var el = document.querySelector('#product-detail__json');
      if (!el) return '';
      var data = JSON.parse(el.textContent);
      return data && data.id != null ? String(data.id) : '';
    } catch (e) {
      return '';
    }
  }

  function shouldApply() {
    if (!cfg) return true;

    var ids = parseIds(cfg.productIds);
    var pid = currentProductId();
    if (ids.length && pid && ids.indexOf(pid) === -1) return false;

    if (cfg.requireBodyClass) {
      return hasClass(cfg.bodyClass || 'ig-bb-otp-link');
    }

    return true;
  }

  function injectCSS() {
    if (document.getElementById(STYLE_ID)) return;
    var s = document.createElement('style');
    s.id = STYLE_ID;
    s.textContent =
      '#' + ROOT_ID + '.ig-otp-link .ig-tg,' +
      '#' + ROOT_ID + '.ig-otp-link .ig-cross{display:none!important}' +
      '#' + ROOT_ID + '.ig-otp-link .ig-alt{display:flex;justify-content:center;margin:0 0 12px}' +
      '#' + ROOT_ID + '.ig-otp-link .ig-alt button{border:none;background:none;font-family:inherit;font-size:14px;font-weight:400;color:#8a938a;cursor:pointer;padding:2px 0;text-decoration:underline;text-decoration-thickness:1px;text-underline-offset:3px;line-height:1.3}' +
      '#' + ROOT_ID + '.ig-otp-link .ig-alt button:hover{color:#3b453b}' +
      '#' + ROOT_ID + '.ig-otp-link .ig-alt button[disabled]{opacity:.55;cursor:wait;pointer-events:none}';
    document.head.appendChild(s);
  }

  function moneyText(el) {
    return (el && el.textContent ? el.textContent : '').replace(/\s+/g, ' ').trim();
  }

  function savePct(otp, sub) {
    var num = function (s) {
      var n = String(s || '')
        .replace(/[^\d.,]/g, '')
        .replace(/,(?=\d{3}\b)/g, '')
        .replace(',', '.');
      return Number(n);
    };
    var a = num(otp);
    var b = num(sub);
    if (!a || !b || a <= b) return 52;
    return Math.round(((a - b) / a) * 100);
  }

  function setPlan(bb, plan) {
    bb.dataset.plan = plan;
    bb.querySelectorAll('.ig-tgb').forEach(function (btn) {
      btn.classList.toggle('active', btn.dataset.p === plan);
    });
    syncSticky(bb);
  }

  function syncSticky(bb) {
    var priceEl = document.querySelector('.sticky-atc__price');
    if (!priceEl) return;
    var sel =
      bb.dataset.plan === 'otp'
        ? '.ig-card.ig-otponly .ig-pr b'
        : '.ig-card.ig-subonly .ig-pr b';
    var price = moneyText(bb.querySelector(sel));
    if (!price) return;
    priceEl.innerHTML =
      '<span class="price-item price-item--regular">' + price + '</span>';
  }

  /**
   * Fire the existing buybox ATC as one-time (no selling_plan),
   * without flipping the visible plan / layout.
   * ATC reads bb.dataset.plan synchronously before any await.
   */
  function addOneTimeToCart(bb, otpBtn) {
    var atc = bb.querySelector('.ig-atc');
    if (!atc || atc.dataset.busy === '1') return;

    var prevPlan = bb.dataset.plan || 'sub';
    if (otpBtn) otpBtn.disabled = true;

    bb.dataset.plan = 'otp';
    atc.click();
    bb.dataset.plan = prevPlan;

    // Re-enable OTP link once ATC finishes (busy flag cleared in finally).
    var tries = 0;
    var timer = setInterval(function () {
      tries += 1;
      if (atc.dataset.busy !== '1' || tries > 80) {
        clearInterval(timer);
        if (otpBtn) otpBtn.disabled = false;
      }
    }, 100);
  }

  function ensureLinks(bb) {
    if (bb.querySelector('.ig-alt')) return true;

    var subPrice = moneyText(bb.querySelector('.ig-card.ig-subonly .ig-pr b'));
    var otpPrice = moneyText(bb.querySelector('.ig-card.ig-otponly .ig-pr b'));
    if (!subPrice || !otpPrice) return false;

    var pct = savePct(otpPrice, subPrice);
    var atc = bb.querySelector('.ig-atc');
    if (!atc) return false;

    var otpShip =
      (cfg && cfg.otpShipping && String(cfg.otpShipping).trim()) ||
      '$4.95 shipping';
    var subShip =
      (cfg && cfg.subShipping && String(cfg.subShipping).trim()) ||
      'free shipping';

    var otpWrap = document.createElement('div');
    otpWrap.className = 'ig-alt ig-subonly';
    otpWrap.innerHTML =
      '<button type="button" data-set="otp">One-time purchase for ' +
      otpPrice +
      ' + ' +
      otpShip +
      '</button>';

    // Kept for parity if plan is ever otp; normally hidden while on sub.
    var subWrap = document.createElement('div');
    subWrap.className = 'ig-alt ig-otponly';
    subWrap.innerHTML =
      '<button type="button" data-set="sub">Subscribe &amp; save ' +
      pct +
      '% for ' +
      subPrice +
      ' + ' +
      subShip +
      '</button>';

    atc.parentNode.insertBefore(otpWrap, atc);
    atc.parentNode.insertBefore(subWrap, atc);

    if (!bb.__otpLinkClick) {
      bb.__otpLinkClick = true;
      bb.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-set]');
        if (!btn || !bb.contains(btn)) return;
        e.preventDefault();
        e.stopPropagation();

        var plan = btn.getAttribute('data-set');
        if (plan === 'otp') {
          addOneTimeToCart(bb, btn);
          return;
        }

        setPlan(bb, plan);
      });
    }

    return true;
  }

  function wireSticky() {
    if (wiredSticky) return;
    wiredSticky = true;
    document.addEventListener(
      'click',
      function (e) {
        var bb = document.getElementById(ROOT_ID);
        if (!bb || !bb.classList.contains('ig-otp-link')) return;
        var sticky = e.target.closest('.sticky-atc-trigger, .sticky-atc__button button');
        if (!sticky) return;
        var atc = bb.querySelector('.ig-atc');
        if (!atc) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        atc.click();
      },
      true
    );
  }

  function applyOnce() {
    if (applying || done) return;
    if (!shouldApply()) return;

    var bb = document.getElementById(ROOT_ID);
    if (!bb) return;
    if (!bb.querySelector('.ig-atc') || !bb.querySelector('.ig-card.ig-subonly')) return;

    applying = true;
    try {
      injectCSS();
      bb.classList.add('ig-otp-link');
      if (!ensureLinks(bb)) return;
      setPlan(bb, bb.dataset.plan || 'sub');
      wireSticky();
      done = true;
    } finally {
      applying = false;
    }
  }

  function waitForBuyBox() {
    applyOnce();
    if (done) return;

    var tries = 0;
    var timer = setInterval(function () {
      tries += 1;
      applyOnce();
      if (done || tries > 80) clearInterval(timer);
    }, 250);
  }

  function watchBodyClass() {
    if (!cfg || !cfg.requireBodyClass) return;

    var last = shouldApply();
    function onClassChange() {
      var now = shouldApply();
      if (now === last) return;
      last = now;
      if (now) {
        done = false;
        waitForBuyBox();
        return;
      }
      var bb = document.getElementById(ROOT_ID);
      if (!bb) return;
      bb.classList.remove('ig-otp-link');
      bb.querySelectorAll('.ig-alt').forEach(function (n) {
        n.remove();
      });
      done = false;
    }

    new MutationObserver(onClassChange).observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['class'],
    });
    new MutationObserver(onClassChange).observe(document.body, {
      attributes: true,
      attributeFilter: ['class'],
    });
  }

  function start() {
    if (!shouldApply()) {
      watchBodyClass();
      return;
    }
    waitForBuyBox();
    watchBodyClass();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
